import redirectPermanently from '@/components/Redirect/redirectPermanently';

const TermsOfService = () => redirectPermanently('/legal/tos');

export default TermsOfService;
